<div class="email-lists-container" data-automation-id="tls-express-email-lists-container" [resBusySpinner]="isBusy"
    [message]="isBusyMessage">
    <div class="header-bar" data-automation-id="tls-express-email-lists-header">
        <button type="button" data-automation-id="tls-express-email-lists-save-button" class="primary-button"
            (click)="saveChanges()" [disabled]="isDisabled()" *ngIf="hasAddEditPermission">Save</button>
        <button type="button" data-automation-id="tls-express-email-lists-discard-changes-button"
            class="secondary-button" (click)="discardChanges()" [disabled]="isDisabled()"
            *ngIf="hasAddEditPermission">Discard Changes</button>
        <!-- <button type="button" class="help-button" data-automation-id="tls-express-email-lists-help-button"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button> -->
    </div>
    <div class="emails-panel">
        <res-key-value-list [placeholderField1]='"Enter an Email address or paste multiple addresses ... "'
            [rows]="emailAddresses" [queryColumnHidden]="true" automationId="tls-express-email-lists"
            [validateName]="false" [maxNameLength]="255" [isDisabled]="!hasAddEditPermission">
        </res-key-value-list>
    </div>
</div>